module.exports = __webpack_public_path__ + "src/assets/games/9/122.jpg";